import type { App, Project } from '@hangar/shared';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { ConnectAppForm } from './ConnectAppForm';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  project: Project;
  onConnected: (app: App) => void;
}

/** Screen 15's form in a sheet: one decision with six fields (Getting started, and anywhere a page cannot host it inline). */
export function ConnectAppSheet({ open, onOpenChange, project, onConnected }: Props) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" data-testid="connect-app-sheet" className="w-full gap-0 p-0" aria-describedby="connect-app-desc">
        <SheetHeader>
          <SheetTitle>Connect app</SheetTitle>
          <SheetDescription id="connect-app-desc" className="text-xs">
            One app per codebase folder of {project.name}; Hangar builds it from its working directory.
          </SheetDescription>
        </SheetHeader>
        <div className="min-h-0 flex-1 overflow-y-auto p-4 sm:p-5">
          {open ? (
            <ConnectAppForm
              projectId={project.id}
              onCancel={() => onOpenChange(false)}
              onDone={(app) => {
                onOpenChange(false);
                onConnected(app);
              }}
            />
          ) : null}
        </div>
      </SheetContent>
    </Sheet>
  );
}
